// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100vh;
  margin: 0;
}
:host .splash-screen-container {
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
}
:host .app-spinner-container {
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 9999;
}

::ng-deep .dark-mode .app-spinner-container {
  background-color: rgba(0, 0, 0, 0.6) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./src/styles/z-index.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,SAAA;AADD;AAGC;EACC,MAAA;EACA,YAAA;EACA,aAAA;EACA,cCVsB;ADSxB;AAIC;EACC,MAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,aCjBoB;ADetB;;AAQE;EACC,+CAAA;AALH","sourcesContent":["@import '../styles/z-index.scss';\n\n:host {\n\theight: 100vh;\n\tmargin: 0;\n\n\t.splash-screen-container {\n\t\ttop: 0;\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t\tz-index: $z-index-splash-screen;\n\t}\n\n\t.app-spinner-container {\n\t\ttop: 0;\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t\tbackground-color: rgba(white, 0.6);\n\t\tz-index: $z-index-app-spinner;\n\t}\n}\n\n::ng-deep {\n\t.dark-mode {\n\t\t.app-spinner-container {\n\t\t\tbackground-color: rgba(black, 0.6) !important;\n\t\t}\n\t}\n}\n","$z-index-splash-screen: 10000;\n$z-index-app-spinner: 9999;\n$z-index-content-spinner: 120;\n$z-index-progress-bar: 210;\n$z-index-side-nav: 200;\n$z-index-backdrop: 150;\n$z-index-scroll-to-top: 210;\n$z-index-top-container: 80;\n$z-index-dynamic-table-header: 10;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
